import { t as gsapWithCSS } from "@theme/gsap";
import { n as ensureSplitText, t as ensureScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/process-steps-animation.js
var ProcessStepsAnimation = class extends HTMLElement {
	async connectedCallback() {
		const [ScrollTrigger, SplitText] = await Promise.all([ensureScrollTrigger(), ensureSplitText()]);
		this.steps = gsapWithCSS.utils.toArray(this.querySelectorAll(".process-step__wrapper"));
		let stepEndsAt = 0;
		const onEnter = (targets) => {
			const now = performance.now();
			const wait = Math.max(0, (stepEndsAt - now) / 1e3);
			const stepTl = gsapWithCSS.timeline({
				defaults: { duration: .5 },
				delay: wait
			});
			stepTl.to(targets[0], {
				x: 0,
				opacity: 1,
				delay: .25
			});
			stepTl.to(targets[1].words, {
				x: 0,
				opacity: 1,
				stagger: { amount: .2 },
				onComplete: () => {
					targets[1].revert();
				}
			}, "<");
			stepTl.to(targets[2].words, {
				x: 0,
				opacity: 1,
				stagger: { amount: .2 },
				onComplete: () => {
					targets[2].revert();
				}
			}, "<0.15");
			stepEndsAt = now + (wait + .3) * 1e3;
		};
		this._triggers = [];
		this.steps.forEach((step) => {
			const number = step.querySelector(".process-step__number");
			const heading = step.querySelector(".process-step__heading");
			const splitHeading = SplitText.create(heading, {
				type: "words",
				aria: true
			});
			const body = step.querySelector(".process-step__body");
			const splitBody = SplitText.create(body, {
				type: "words",
				aria: true
			});
			gsapWithCSS.set(number, {
				x: -5,
				opacity: 0
			});
			gsapWithCSS.set([splitHeading.words, splitBody.words], {
				x: -10,
				opacity: 0
			});
			this._triggers.push(ScrollTrigger.create({
				trigger: step,
				onEnter: () => {
					onEnter([
						number,
						splitHeading,
						splitBody
					]);
				}
			}));
		});
	}
	disconnectedCallback() {
		this._triggers?.forEach((t) => t.kill());
	}
};
window.customElements.define("process-steps-animation", ProcessStepsAnimation);
//#endregion
